import { ChevronDown } from 'lucide-react';
import { zustandTextfarbe } from '@/lib/zustandFarbe';
import { zustandAnzeige } from '@/lib/zustandLabel';

/**
 * Das Zustands-Pillchen im Brett.
 *
 * `versandartCode` ist Pflicht, nicht optional (A11.2): „Bereit" heisst
 * bei einer Abholung „Abholbereit", und „Abgeschlossen" heisst je nach
 * Weg „Abgeholt" oder „Versendet". (Bei Versand gibt es „Bereit" seit
 * A46 gar nicht mehr — die Pille zeigt ihn dort nur noch, wenn eine
 * alte Bestellung darin haengengeblieben ist.) Waere der Parameter optional, koennte
 * eine neue Aufrufstelle ihn stillschweigend weglassen — und dieselbe
 * Bestellung hiesse im Brett anders als in ihrer Ansicht. Wer die
 * Versandart wirklich nicht kennt, uebergibt ausdruecklich `null`; dann
 * bleibt es beim neutralen Wort.
 */
type Props = {
  code: string;
  label: string;
  color: string | null;
  versandartCode: string | null;
  /**
   * Winkelzeichen anhaengen (A12.7). Es sagt, dass hier etwas zu waehlen
   * ist — auf einem Tablet die einzige Moeglichkeit dazu, denn ein
   * Zeichen, das nur beim Ueberfahren erscheint, erscheint dort nie.
   */
  chevron?: boolean;
};

export function ZustandPill({ code, label, color, versandartCode, chevron }: Props) {
  // E61: die Farbe aus der Datenbank, abgedunkelt, falls sie als Schrift
  // nicht 4,5 : 1 hält. Ohne Farbe das Rückfall-Grau aus theme.ts — bis
  // E61 nahm diese Stelle Ink-faint, der Schalter in der Bestellung
  // Ink-soft: zwei Graus für dieselbe Sache (vgl. A14.3).
  const farbe = zustandTextfarbe(color);
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs"
      style={{ borderColor: farbe, color: farbe }}
    >
      <span aria-hidden className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: farbe }} />
      <span className="whitespace-nowrap">{zustandAnzeige(code, label, versandartCode)}</span>
      {chevron === true && <ChevronDown aria-hidden className="h-3 w-3 shrink-0" />}
    </span>
  );
}
